import React, { useContext } from "react";

import constant from "lib/constant/constant";
import { PrivateContext } from "lib/context";
import { SkeletonAnnotated } from "lib/components";
import { storageHelper } from "lib/helpers";
import { withErrorBoundary } from "lib/hoc";

import OperatorAnalytics from "app/analytics/modules/operator/analytics";
import ProviderAnalytics from "app/analytics/modules/provider/analytics";

const { userKey } = constant;
const { operator, provider } = userKey;

const Analytics = () => {
  const { isLoading } = useContext(PrivateContext);

  const getComponent = (role) => {
    if (isLoading) {
      return <SkeletonAnnotated />;
    }
    if (role === operator) {
      return <OperatorAnalytics />;
    }
    if (role === provider) {
      return <ProviderAnalytics />;
    }
    return null;
  };

  const currentUserRole = storageHelper.get("userRole");
  const AnalyticComponent = getComponent(currentUserRole);
  return AnalyticComponent;
};

export default withErrorBoundary(Analytics);
